/* eslint-disable */
import React from 'react';

/**
 * Tier pattern used across the platform:
 *   free → simple → expensive → unlimited → Unlimited+ (Plus tier, #216)
 *
 * The Plus tier accepts three interchangeable description-tag values so admins
 * can use whichever reads best:
 *   [LMS:eligibility=lifetime+]   ← legacy key (still stored on 2 prod webinars)
 *   [LMS:eligibility=plus]        ← matches exam_plans.package_val enum
 *   [LMS:eligibility=unlimited+]  ← matches the product's display name
 * All three render the same badge and grant the same access.
 */
const PLUS_ENTRY = { text: 'Unlimited+ Package' };

const EL_LEVELS = {
    'free': {
        text:'Free',
        className: 'free-label'
    },
    'simple': {
       text: 'Practice Package',
       className: 'practice-label'
    },
    'expensive': {
        text: 'Learn & Practice Package',
        className: 'learn-label'
    },
    'unlimited': {
        text:'Unlimited Package'
    },
    // Plus-tier aliases — all three point to the same entry so the display
    // label stays consistent regardless of which tag the admin used.
    'lifetime+':   PLUS_ENTRY,
    'plus':        PLUS_ENTRY,
    'unlimited+':  PLUS_ENTRY,
    // Legacy single-word `lifetime` — kept for back-compat with any old rows,
    // folded into the Plus display now that the product has been renamed.
    'lifetime':    PLUS_ENTRY,
}

const AccessLabel = ({ eligibilityLevel, accessibility }) => {

    // Guard the lookup: `EL_LEVELS[undefined].text` throws. Normalise to lowercase
    // so case variants from Graph API (e.g. "Free", "LIFETIME") still resolve.
    const normalizedLevel = eligibilityLevel != null ? String(eligibilityLevel).toLowerCase() : null;
    const levelEntry = normalizedLevel ? EL_LEVELS[normalizedLevel] : null;
    const accessLabel = (levelEntry && levelEntry.text) || 'Unknown';
    const classesNames = [
        'webinar-card__access-badge'
    ];

    if(normalizedLevel === 'free'){
        classesNames.push('webinar-card__access-badge--free');
    }else{
        classesNames.push(accessibility === true ? 'webinar-card__access-badge--prem-av' :'webinar-card__access-badge--prem-nav');
    }

    const iconsSvg = {
        open: (
            <svg className="wb-svg-icon-12" viewBox="0 0 24 24" fill="none" stroke="#16a34a" strokeWidth="2" ><rect x="3" y="11" width="18" height="11" rx="2"></rect><path d="M7,11V7a5,5,0,0,1,9.9-1"></path></svg>
        ),
        close: (
            <svg className="wb-svg-icon-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <rect x="3" y="11" width="18" height="11" rx="2"></rect>
                <path d="M7,11V7a5,5,0,0,1,10,0v4"></path>
            </svg>
        )
    }

    const IconItem = () => {
        if (normalizedLevel === 'free') return null;
        return accessibility === true ? iconsSvg.open : iconsSvg.close
    };

    return (
        <span className={classesNames.join(' ')}>
            <IconItem />
            {accessLabel}
        </span>
    )
}

export default AccessLabel;



// WEBPACK FOOTER //
// ./src/components/Webinars/AccessLabel.js